import { render, staticRenderFns } from "./PermissionGroupPicker.vue?vue&type=template&id=3f4fcac8&scoped=true"
import script from "./PermissionGroupPicker.vue?vue&type=script&lang=js"
export * from "./PermissionGroupPicker.vue?vue&type=script&lang=js"
import style0 from "./PermissionGroupPicker.vue?vue&type=style&index=0&id=3f4fcac8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4fcac8",
  null
  
)

export default component.exports